import { createFileRoute, useParams } from "@tanstack/react-router"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import { getProjectById } from "@/api/services/projects"
import ProjectDetail from "@/pages/contracten/contract_detail/ProjectDetail"
import { projectQueryKeys } from "@/api/query-keys/projects"
import { checkPermissions } from "@/utils/checkPermissions"

export const Route = createFileRoute(
  "/beheer/contracten/$contractId/organisaties/$organization",
)({
  component: OrganizationOverview,
  beforeLoad: () => checkPermissions("read", "projects"),
})

function OrganizationOverview() {
  const { contractId, organization } = useParams({
    from: "/beheer/contracten/$contractId/organisaties/$organization",
  })

  const { data: organizations } = useSuspenseQuery({
    queryKey: projectQueryKeys.detail(Number(contractId)),
    queryFn: () => getProjectById(Number(contractId)),
    select: (data) => data.data.organizations,
  })

  const activeOrganization = useMemo(() => {
    return organizations.find(
      (c) => c.id === Number(organization) || c.name === organization,
    )
  }, [organization, organizations])

  return (
    <>
      {activeOrganization && <ProjectDetail />}
      {!activeOrganization && (
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500">
            Selecteer een organisatie om de planning te bekijken
          </p>
        </div>
      )}
    </>
  )
}
